<template>
    <div class="b-error">
        <div class="b-error__cont">
            <div class="b-error__icon icon-error"></div>
            <div class="b-error__txt" v-html="errorMessages"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        errorMessages: {
            type: String,
            default: '',
        },
    },
}
</script>
